import { createContext, useContext } from "react";

// Network-origin theme mode, provided by ThemeController and consumed app-wide.
//   isUta      - true only once the network check has resolved AND the visitor is on the UTA network
//   isResolved - false while GET /api/client-network is in flight
export const ThemeModeContext = createContext({ isUta: false, isResolved: false });

export const useThemeMode = () => useContext(ThemeModeContext);
